import { Head, usePage } from "@inertiajs/react"
import { AdminShell } from "@/components/AdminShell"
import { PageHeader } from "@/components/PageHeader"
import { ArticleForm, type ConditionOption, type PageOption, type TherapyOption } from "./ArticleForm"
import type { LibraryPhoto } from "@/components/pages-cms/types"
import type { PageProps } from "@/types/inertia"

const BLANK_ARTICLE = {
  title_en: "",
  title_es: "",
  slug: "",
  slug_es: "",
  body_en: "",
  body_es: "",
  excerpt_en: "",
  excerpt_es: "",
  category: "",
  author: "",
  read_time: null,
  thumbnail: "",
  published_at: null,
  status: "draft",
  goal: "",
  brand: "gisela",
  condition_slug: "",
  therapy_slug: "",
  page_slug: "",
}

export default function ArticlesNew() {
  const { props } = usePage<
    PageProps & {
      conditions: ConditionOption[]
      therapies: TherapyOption[]
      pages: PageOption[]
      photo_library: LibraryPhoto[]
    }
  >()

  return (
    <AdminShell>
      <Head title="New Article">
        <meta name="description" content="Create a new article for Sanctuary Therapy Centre." />
        <meta property="og:title" content="New Article" />
        <meta property="og:description" content="Create a new article for Sanctuary Therapy Centre." />
      </Head>
      <PageHeader title="New Article" />
      <div className="mt-8 max-w-2xl">
        <ArticleForm
          article={BLANK_ARTICLE}
          actionUrl="/admin/articles"
          method="post"
          conditions={props.conditions}
          therapies={props.therapies}
          pages={props.pages}
          photoLibrary={props.photo_library}
        />
      </div>
    </AdminShell>
  )
}
